import React from "react";
import { Box } from "@mui/material";

// Navbar import removed
// import Navbar from "./Navbar"; 

const Layout = ({ children }) => {
  return (
    <Box // This Box is now the main content area itself
      component="main"
      sx={{
        flexGrow: 1, // This will be important if App.js uses flex for the content area
        overflowY: 'auto',
        p: 3,
        height: '100%' // Ensure it tries to fill its container from App.js
      }}
    >
      {/* The Navbar is no longer here */}
      {children}
    </Box>
  );
};

export default Layout;
